var _String = {};

_String.trim = function(str) {
	return (str || "").replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "");
};

_String.hashCode = function(str){
	var hash = 0, i, chr, len;
	if (str.length === 0) return hash;
	for (i = 0, len = str.length; i < len; i++) {
		chr   = str.charCodeAt(i);
	    hash  = ((hash << 5) - hash) + chr;
	    hash |= 0; // Convert to 32bit integer
	}
	return hash;
};

_String.splitAndTrim = function(str, spliter) {
	if(!str) return [];
	var result = str.split(spliter);
	for ( var i=0; i<result.length; i++) {
		result[i] = _String.trim(result[i]);
	}
	return result;
};

_String.format = function() {
	if (arguments.length === 0)
		return null;
	var str = arguments[0];
	if (str && (typeof str.replace === "function")){
		var args = arguments;
		var ret = str.replace(/\{(\d+)\}/g, function(m, i){
			var i = i*1 + 1;
			return args.length>i ? args[i] : m;
		});
		return ret;
	}else{
		return str;
	}
};

_String.toStr = function(v){
	return v===null || v===undefined?"":String(v);
};

_String.toInt = function(str, defaultValue) {
	var result = parseInt(str, 10);
	return (isNaN(result)) ? defaultValue : result;
};

_String.toFloat = function(str, defaultValue) {
	var result = parseFloat(str);
	return (isNaN(result)) ? defaultValue : result;
};

_String.fromFloat = function(num, i) {
	i = Math.abs(i);
	if(i>0){
		num = ''+num;
		let ipos = num.indexOf('.');
		let decimal = '';
		let int = num;
		if(ipos>=0){
			decimal = num.substring(ipos+1);
			int = num.substring(0,ipos);
		}
		if(decimal.length<i){
			let ret = int + '.' + decimal;
			return _String.zeros(ret,ret.length+(i-decimal.length),true);	
		}else if(decimal.length===i){
			return int + '.' + decimal;
		}else{
			num = new Number(num);
			return num.toFixed(i);
		}
	}else{
		return ''+Math.round(num);
	}
};

_String.zeros = function(value, length, right) {
	var res = "" + (null===value||undefined===value?'':value);
	for (; res.length < length; res = right ? res + '0' : '0' + res) {
	}
	return res;
};

_String.camelize = function(str, lowFirstLetter) {
	if (!str) return str;
	str = str.toLowerCase();
	return str.charAt(0).toUpperCase() + str.substring(1);
};

_String.substring = function(str,start,stop){
	return (typeof(str)==='string' && str)?str.substring(start,stop):"";
};

_String.stringFormatByKey = function(str, params) {
	return str.replace(/{(\w+)}/g, function (match, key) {
		return typeof params[key] != 'undefined' ? params[key] : match;
    });
};

_String.jsonI18n = function(data, keys, pageI18nFunc) {
    for (let item of data) {
        for (let key of keys) {
            item[key] = pageI18nFunc(item[key]);
        }
    }
}
export default _String;
